import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box } from '@mui/material'
import type { ConversationTurnEntry } from '@/features/events/conversation/state/types'
import { extractEventContent } from '../utils'
import { MarkdownRenderer } from '../markdown'
import { BaseBubble } from './BaseBubble'

interface AgentNarrativeBubbleProps {
  readonly event: ConversationTurnEntry
  readonly showTimestamp?: boolean
  readonly onEventDetailsClick?: (event: ConversationTurnEntry) => void
}

export const AgentNarrativeBubble: FC<AgentNarrativeBubbleProps> = ({
  event,
  showTimestamp = true,
  onEventDetailsClick,
}) => {
  const eventContent = extractEventContent(event)

  return (
    <BaseBubble
      event={event}
      showTimestamp={showTimestamp}
      onEventDetailsClick={onEventDetailsClick}
    >
      <Box sx={contentContainerSx}>
        <MarkdownRenderer content={eventContent} />
      </Box>
    </BaseBubble>
  )
}

const contentContainerSx: SxProps<Theme> = {
  width: '100%',
}
